import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ResponsiveService } from '@cf/core';
import { CfDialogContentDirective, CfDialogDismissDirective } from '@cf/shared/dialog';
import { ButtonDirective } from '@cf/shared/ui/button';
import { CfIconDirective } from '@cf/shared/ui/icons';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'cf-icloud-hint',
  imports: [
    CommonModule,
    ButtonDirective,
    CfDialogContentDirective,
    CfDialogDismissDirective,
    NgxTolgeeModule,
    CfIconDirective,
  ],
  templateUrl: './icloud-hint.component.html',
})
export class ICloudHintComponent {
  #responsiveService = inject(ResponsiveService);

  isMobile$ = toSignal(this.#responsiveService.isMobile$);
  isIosMobile = computed(() => {
    if (!this.isMobile$()) return false;

    const userAgent = window.navigator.userAgent;
    return (
      (/iPad|iPhone|iPod/.test(userAgent) ||
        // eslint-disable-next-line no-untranslated-string/no-untranslated-string
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
      this.isMobile$()
    );
  });
}
